import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsIn, IsOptional, IsString, MaxLength } from 'class-validator';

export class UpdateReciboCobroDto {
  @ApiPropertyOptional({ example: 'anulado' })
  @IsString()
  @IsOptional()
  @IsIn(['emitido', 'anulado'], { message: 'Estado debe ser emitido o anulado' })
  estado?: string;

  @ApiPropertyOptional({ example: 'Anulado por error en el monto' })
  @IsString()
  @IsOptional()
  @MaxLength(500)
  observacion?: string;
}
